import React, { useState } from 'react';
import { normalizeDomain, validateOrganizationDomain } from '../utils/domainUtils';
import './EduDomainDialog.css';

const EduDomainDialog = ({ onSubmit, onCancel, initialDomain = '' }) => {
  const [domain, setDomain] = useState(initialDomain);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationError = validateOrganizationDomain(domain);
    if (validationError) {
      setError(validationError);
      return;
    }

    onSubmit(normalizeDomain(domain));
  };

  const handleChange = (e) => {
    setDomain(e.target.value);
    if (error) {
      setError('');
    }
  };

  return (
    <div className="dialog-overlay">
      <div className="dialog-content edu-domain-dialog">
        <h2>Enter Your Organization Domain</h2>

        <div className="edu-domain-help">
          <p>
            Enter the email domain for your school or organization. You can use
            <strong> .edu or another organization-owned domain</strong>, but common
            personal email domains like Gmail, Yahoo, and Outlook are not allowed.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group domain-input-group">
            <label htmlFor="organizationDomain">
              Organization Domain <span className="required">*</span>
            </label>
            <input
              id="organizationDomain"
              type="text"
              value={domain}
              onChange={handleChange}
              placeholder="e.g., university.edu or organization.org"
              className={`domain-input ${error ? 'error' : ''}`}
            />
            {error && (
              <span className="error-message">{error}</span>
            )}
            <small className="form-hint">
              Enter the domain without @. Do not use common personal email domains.
            </small>
          </div>

          <div className="dialog-buttons">
            <button type="button" onClick={onCancel} className="dialog-button cancel-button">
              Cancel
            </button>
            <button type="submit" className="dialog-button submit-button">
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EduDomainDialog;
